import { Range } from 'slate';
export default function emptyTableCell(editor, cell) {
  return editor.withoutNormalizing(function () {
    var range = Range.create().moveToRangeOfNode(cell);
    editor.deleteAtRange(range);
  });
}